export enum authenticationErrorCodes {
  wrong_password = 'wrong_password',
  username_doesnt_exist = 'username_doesnt_exist',
  missing_password = 'missing_password',
  missing_username = 'missing_username',
}
